import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { Observable } from 'rxjs';
import { NotificationService } from "src/app/notification.service";
@Injectable({
  providedIn: "root",
})
export class PixelService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/conversion-pixel/`;
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  getAllPixel(params = {}): Observable<any> {
    let params_url = this.convertToString(params)
    let url = `${this.BASE_API_URL}/pixel/`;
    if (params_url.length > 0) {
      url = `${this.BASE_API_URL}/pixel/?${params_url}`
    }
    return this.get(url);
  }
}

@Injectable({
  providedIn: "root",
})
export class SegmentService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/segment/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  getThirdPartySegment(params = {},) {
    let url = this.buildUrl(`${this.BASE_API_URL}/third-party-segment/`, '', params)
    return this.get(url)
  }

  getThirdPartySegmentDetails(id, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/third-party-segment/`, id, params)
    return this.get(url)
  }

  updateThirdPartySegment(id, segment_data, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/third-party-segment/`, id, params)
    return this.put(url, segment_data)
  }

  deleteThirdPartySegment(id, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/third-party-segment/${id}`, '', params)
    return this.delete(url)
  }

  segmentPush(id, segment_data, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/push/`, '', params)
    return this.post(url, segment_data)
  }

  segmentPushHistory(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/push-history/`, '', params)
    return this.get(url)
  }

}
